import { Toaster } from 'react-hot-toast';
import { ColorModeProvider } from '@antimatterhq/ui/contexts/ColorModeContext';
import { TanStackQueryClientProvider } from '@/providers/query';
import { AppRouterProvider } from '@/providers/router';
import { InstanceIdProvider } from '@/contexts/InstanceIdContext';
import { StandaloneRequestHandlersProvider } from '@/providers/request-handlers';
import { WindowEnvironmentProvider } from '@/providers/window-environment';
import FeatureFlagProvider from '@/contexts/FeatureFlagContext';

export const Providers = () => {
  return (
    <ColorModeProvider>
      <InstanceIdProvider>
        <FeatureFlagProvider>
          <WindowEnvironmentProvider>
            <TanStackQueryClientProvider>
              <StandaloneRequestHandlersProvider>
                <AppRouterProvider />
              </StandaloneRequestHandlersProvider>
            </TanStackQueryClientProvider>
          </WindowEnvironmentProvider>
        </FeatureFlagProvider>
        <Toaster position="bottom-right" />
      </InstanceIdProvider>
    </ColorModeProvider>
  );
};
